import React from 'react';

const LandingSubText = ({ children, additionalclasses }) => {
    return (
        <p className={`font-geist !text-[#B0B0B0] lg:text-[#858585] text-[16px] lg:text-[18px] leading-[24px] lg:tracking-[-0.4px] text-center ${additionalclasses}`}>
            {children}
        </p>
    );
};

export default LandingSubText;